import React from 'react';
import { connect } from 'dva';
import ABSAvatar from '../../../../../components/ABSAvatar';
import ABSProgressBarLine from '../../../../../components/ABSProgressBarLine';
import ABSLabelValueList from '../../../../../components/ABSLabelValueList';
import ABSComment from '../../../../../components/ABSComment';
import { ABSButton } from '../../../../../components/ABSButton';
import routerConfig from '../../../../config/routeConfig';
import { IhomeAccountInfo } from './util';
import moment from 'moment';
import { ABSModal } from '../../../../../components/ABSModal';
import ABSParagraph from '../../../../../components/ABSParagraph';
import ABSInput from '../../../../../components/ABSInput';
import ABSMessage from '../../../../../components/ABSMessage';
import ABSIcon from '../../../../../components/ABSIcon';
import ABSLink from '../../../../../components/ABSLink';
import CommonUtils from '../../../../../utils/commonUtils';
import { ABSConfirm } from '../../../../../components/ABSConfirm';

declare var Q: Window & { clipboardData: any  };
export interface IUserProps {
  isLogin: boolean;
  homeAccountInfo: IhomeAccountInfo;
  dispatch?: any;
  totalPoint: number;
}

export interface IUserState {
  textareaValue: string;
}

class User extends React.Component<IUserProps, IUserState> {
  modal;
  vipModal;
  vipConfirm;
  vipInputGroup: any[] = [];
  introductionName = 'CNABS专业版权限介绍';
  constructor(prop: any) {
    super(prop);
    this.state = {
      textareaValue: ''
    };
  }
  getAccountInfo = () => {
    this.props.dispatch({
      type: 'home/getHomePageAccountInfo'
    });
  }
  componentDidMount() {
    const { isLogin } = this.props;
    if (isLogin) {
      this.getAccountInfo();
    } 
  }

  goRegister = () => {
    location.href = routerConfig.registerOfIntroduction;
  }
  goLogin = () => {
    location.href = routerConfig.login;
  }

  onAccountUpgrade = () => {    
    this.modal.show( true );
  }

  onVipUpgrade = () => {
    this.vipModal.show(true);
  }

  onChange = (value) => {
    this.setState({
      textareaValue: value
    });
  }

  onVipPwdKeyUp = (event, i) => {
    if (event.keyCode === 8) {
      // 删除健
      return; 
    }
    if (event.ctrlKey || event.metaKey) {
      // ctrlKey为Ctrl键，metaKey为MacOS的Command键
      if (event.keyCode === 86) {
        // ctrl + v
        return;
      }
    }
    const val = event.target.value.replace(/ /g, '');
    if (val && val.length >= 4) {
      this.vipInputGroup[i].blur();
      setTimeout(() => {
        this.vipInputGroup[i].setValue(val.substr(0, 4));  
        if (i !== 2) {
          this.vipInputGroup[i + 1].focus(); 
        }
      }, 10);
    }
  };

  onVipPaste = (e: any) => {
    const clipboardData = e.clipboardData || Q.clipboardData;
    const pastedData = clipboardData.getData('Text');
    const val = pastedData.replace(/ |[\r\n]/g, '');
    if (val.length >= 12) {
      e.stopPropagation();
      e.preventDefault();
      this.vipInputGroup[0].setValue(val.substr(0, 4));
      this.vipInputGroup[1].setValue(val.substr(4, 4));
      this.vipInputGroup[2].setValue(val.substr(8, 4));
      e.target.blur();
    }
  }

  downloadIntroduction = () => {
    this.props.dispatch({
      type: 'account/getUseInstructionList',
      payload: {
        page_index: -1 // 拿使用帮助页面所有文件对比
      }
    }).then((res) => {
      const introduction = res.find((file) => { return file.title.indexOf(this.introductionName) !== -1; });
      const fileUrl = `${introduction.file_url}`;
      if (!fileUrl) { return; }
      CommonUtils.downloadFile(fileUrl);
    });
  }
  renderModalContent() {
    const { textareaValue } = this.state;
    return (
      <div>
        <ABSParagraph>【专业版】需要与您所在的机构签约付费，开通相应权限及专业化服务</ABSParagraph>
        <ABSInput 
          className="abs-change-account-type-input" 
          type="textarea"
          height={140}
          value={textareaValue} 
          placeholder="请在此处描述您的其他问题，我们将尽快回复您" 
          onChange={this.onChange} 
          areaMaxLen={2000}
        />
        <a onClick={this.downloadIntroduction}>{this.introductionName}</a>
      </div>
    );
  }
  renderVipModalContent() {
    return (      
      <div>
        <ABSParagraph>请输入VIP体验卡12位激活码：</ABSParagraph>
        <ABSInput 
          className="abs-vip-input" 
          placeholder="例：6W6Z" 
          onKeyUp={(e) => this.onVipPwdKeyUp(e, 0)}
          onPaste={this.onVipPaste}
          ref={(view) => { this.vipInputGroup.push(view); }}
        />
        <span className="abs-vip-split">-</span>
        <ABSInput 
          className="abs-vip-input" 
          placeholder="6W6Z" 
          onKeyUp={(e) => this.onVipPwdKeyUp(e, 1)}
          onPaste={this.onVipPaste}
          ref={(view) => { this.vipInputGroup.push(view); }}
        />
        <span className="abs-vip-split">-</span>
        <ABSInput 
          className="abs-vip-input" 
          placeholder="6W6Z" 
          ref={(view) => { this.vipInputGroup.push(view); }}
          onKeyUp={(e) => this.onVipPwdKeyUp(e, 2)}
          onPaste={this.onVipPaste}
        />
      </div>
    );
  }

  onSuccessCallback = () => {
    const { textareaValue } = this.state;
    this.props.dispatch({
      type: 'account/submitFeedback',
      payload: {
        type: 9,
        content: textareaValue ? textareaValue : '我要升级'
      }
    }).then((response) => {
      if (response) {
        ABSMessage.success('提交成功');
        this.setState({textareaValue: ''});
        this.modal.show(false);
      }
    });
    return true;
  }

  onVipSuccessCallback = () => {    
    if (Array.isArray(this.vipInputGroup) && this.vipInputGroup.length === 3) {
      const cardPassword = this.vipInputGroup.map((inputField) => {
         if (inputField) {
          return inputField.getValue();
         } else {
           return '';
         }
      });
      if (cardPassword.join('').length < 12) {
        ABSMessage.error('请填写完整的激活码');
        return;
      }
      this.props.dispatch({
        type: 'account/activateVip',
        payload: {
          pwd : cardPassword.join('')
        }
      }).then((response) => {
        if (response === 'ok') {
          this.resetVipInputs();
          this.vipModal.show(false);
          this.vipConfirm.show(true);
        } else {
          if (response) {
            ABSMessage.error(response); 
          }
        }
      });
    }
  }

  resetVipInputs = () => {
    for (let i = 0; i < this.vipInputGroup.length; i++) {
      const item = this.vipInputGroup[i];
      if (item) {
        item.reset();
      }
    }
  }
  renderRole() {
    const { homeAccountInfo } = this.props;
    const duteDateComment = <ABSComment>（有效期至 {moment(homeAccountInfo.enterprise_type.due_date).format('YYYY-MM-DD')}）</ABSComment>;
    let content: any = '';
    if ( homeAccountInfo.enterprise_type.type.indexOf('专业版') > -1) {
      content = duteDateComment;
    } else if (homeAccountInfo.enterprise_type.type.indexOf('VIP体验版') > -1) {
      content = (
        <>
          {duteDateComment}
          <ABSButton style={{ marginLeft: 0 }} isHollow={true} onClick={this.onAccountUpgrade}>账号升级</ABSButton>
        </>
      );
    } else {
      content = (
        <>
          <ABSButton isYellow={true} onClick={this.onVipUpgrade}>VIP体验卡</ABSButton>
          <ABSButton isHollow={true} onClick={this.onAccountUpgrade}>账号升级</ABSButton>
        </> 
      );
    }
    return (
      <>
        <span className="abs-account-type">{homeAccountInfo.enterprise_type.type}</span>
        {content}
      </>
    );
  }
  renderDiffTypeContent() {
    const { isLogin, homeAccountInfo } = this.props;
    if (!isLogin) {
      return (
        <div className="abs-home-user-nologin-btn">
          <ABSButton onClick={this.goLogin}>立即登录</ABSButton>
          <ABSButton className="abs-home-user-nologin-btn-register" onClick={this.goRegister}>免费注册</ABSButton>
        </div>
      );
    }
    if (!homeAccountInfo || !homeAccountInfo.enterprise_type) { return ''; }
    return (
      <>
        <ABSProgressBarLine percent={homeAccountInfo.score} width={150} displayType="line" text="履历完善度" />
        <ABSLabelValueList
          list={[
            {
              content: (this.renderRole() )
            }]}
        />
        <ABSModal
          content={this.renderModalContent()}
          title="账号升级咨询"
          width={520}
          onConfirm={this.onSuccessCallback}
          ref={view => this.modal = view}
          className="abs-home-account-upgrade-modal"
        />
        <ABSModal
          content={this.renderVipModalContent()}
          title="VIP体验卡激活"
          width={520}
          onConfirm={this.onVipSuccessCallback}
          onClose={this.resetVipInputs}
          ref={view => this.vipModal = view}
          className="abs-home-vip-modal"
          maskClosable={false}
        />
        <ABSConfirm
          content={`重新登录后生效`}
          title="激活成功"
          width={360}
          onConfirm={() => {
            this.props.dispatch({
              type: 'global/logout',
              payload: {
                returnUrl: routerConfig.login  
              }
            });
          }}
          btnText="立即重新登录"
          ref={view => (this.vipConfirm = view)}
        />
      </>
    );
  }

  render() {
    const { isLogin, homeAccountInfo, totalPoint = 0 } = this.props;
    return (
      <div className="abs-home-user">
        <div className="abs-home-user-info">
          <ABSAvatar
            size="large"
            imageUrl={homeAccountInfo.avatar}
          />
          {isLogin ?
            (
              <div className="abs-home-user-info-right">
                <div className="abs-home-user-info-right-name">
                  <span>{homeAccountInfo.name}</span>，您好！
                <ABSLink to={routerConfig.userProfile} target="_blank"><ABSIcon size={16} type="write-mail" /></ABSLink>
                </div>
                {/* <div className="abs-home-user-info-right-description">用户名: {homeAccountInfo.user_name}</div> */}
                <div className="abs-home-user-info-right-description">当前积分: {totalPoint}</div>
                <div className="abs-home-user-info-right-description">上次登录: {moment(homeAccountInfo.last_login_date).format('YYYY-MM-DD HH:mm')}</div>
              </div>
            ) :
            <div className="abs-home-user-info-right">
              <span className="abs-home-user-info-right-nologin">请先登录</span>
            </div>
          }
        </div>
        {this.renderDiffTypeContent()}
      </div>
    );
  }
}

function mapStateToProps({ home, global, loading }: any) {
  const { homeAccountInfo } = home;
  return { homeAccountInfo, totalPoint: global.totalPoint};
}

export default connect(mapStateToProps)(User);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/right/User.tsx